export const BITE_PRICE_OFFER_EVENT='bite:price-offer';
export function openBitePriceOffer(){
  window.dispatchEvent(new Event(BITE_PRICE_OFFER_EVENT));
}
